import { Text } from "@meditect/medibase-components";

export const SalesCannotEditCanceledSaleError = () => {
  return <Text>Cette vente a déjà été annulée.</Text>;
};
